import React, { ChangeEvent } from "react";
import { translate } from "../services/AppService";


interface Props { 
    model: string,
    class?: string,
    label?: string,
    placeholder?: string,
    elmKey?:string,
    id?:string,
    onChange?:(...args:any) => void ,
    onEnterClicked?:(...args:any) => void ,
}

export default function Password(props:Props) {
    const [controle, setControle] = React.useState({
        hiddeStat: true
    });

    function handleChange(event:ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(value, props.elmKey);
    }

    function SetEyeStat() {
        setControle((old) => {
            return {
                hiddeStat: !old.hiddeStat,
            };
        });
    }

    function hanldeKeydown(evt:React.KeyboardEvent<HTMLInputElement>) {
        if (evt.key === 'Enter' && props.onEnterClicked && typeof (props.onEnterClicked) == "function")
            props.onEnterClicked();
    }
    return (
        <div className="mt-2">
            <label className="form-label fw-semibold mb-0 ps-1 text-primary-emphasis">
                {translate(props.label)}
            </label>

            <div className="input-group input-group-sm border rounded focus-group">
                <input
                    className={`form-control form-control-sm rounded-s ` + props.class}
                    type={controle.hiddeStat ? "password" : "text"}
                    id={props.id ? props.id : "pass" + props.label}
                    onChange={handleChange}
                    value={props.model}
                    onKeyDown={hanldeKeydown}
                    placeholder={translate(props.placeholder)}
                    autoComplete="off"
                />

                <button className="btn btn-sm bg-body rounded-e p-0 px-2" type="button" onClick={SetEyeStat}>
                    {controle.hiddeStat ? (
                        <i className="iconssc-eye fs-5 text-primary-emphasis"></i>
                    ) : (
                        <i className="iconssc-eye-hide fs-5 text-primary-emphasis"></i>
                    )}
                </button>
            </div>
        </div>
    );
}


Password.defaultProps = {
    class: " border-0",
    label: "Password",
    placeholder: "password",
};